import React, { useState, Children, cloneElement, isValidElement } from 'react';
export const Tabs = ({
  defaultValue,
  children,
  className
}) => {
  const [activeTab, setActiveTab] = useState(defaultValue);
  return <div className={className} data-id="element-3897" data-mp="cxrwllzvbp0i">
      {Children.map(children, child => {
      if (isValidElement(child)) {
        return cloneElement(child, {
          activeTab,
          setActiveTab
        });
      }
      return child;
    })}
    </div>;
};
export const TabsList = ({
  children,
  className,
  activeTab,
  setActiveTab
}) => {
  return <div className={className} data-id="element-3898" data-mp="7zq7ajbumtgl">{children}</div>;
};
export const TabsTrigger = ({
  value,
  children,
  activeTab,
  setActiveTab
}) => {
  return <button className={`px-4 py-2 rounded-md text-sm font-medium ${activeTab === value ? 'bg-indigo-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setActiveTab && setActiveTab(value)} data-id="element-3899" data-mp="3vb9bd0r0kq4h">
      {children}
    </button>;
};
export const TabsContent = ({
  value,
  children,
  activeTab
}) => {
  if (value !== activeTab) return null;
  return <div className="mt-4" data-id="element-3900" data-mp="c0nn7bkzk07q">{children}</div>;
};